import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-new-footer-v2',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './new-footer-v2.component.html',
  styleUrl: './new-footer-v2.component.scss'
})
export class NewFooterV2Component {
  @Input() selectedLanguage: string = 'en';
  @Input() gtmTags: any = {};
}
